import { render, staticRenderFns } from "./TopMenuAdmin.vue?vue&type=template&id=0b8c77e7&scoped=true"
import script from "./TopMenuAdmin.vue?vue&type=script&lang=js"
export * from "./TopMenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./TopMenuAdmin.vue?vue&type=style&index=0&id=0b8c77e7&prod&lang=scss&scoped=true"
import style1 from "./TopMenuAdmin.vue?vue&type=style&index=1&id=0b8c77e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c77e7",
  null
  
)

export default component.exports